export const getFullName = ({ user }) => `${user.lastName} ${user.firstName}`
